import z from 'zod';

export const updatePlanSchema = z.object({
  title: z.string().max(255).nullable(),
  description: z.string().optional(),
  duration_in_months: z.number().min(1).max(18).nullable(),
});
